import { useEffect, useState } from "react";
import client from "../api/client";

const empty = {
  supplierCode: "",
  supplierName: "",
  email: "",
  phone: "",
  addressLine: "",
  gstNo: "",
};
const val = (r, a, b) => r?.[a] ?? r?.[b] ?? "";

export default function SuppliersPage() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const companyId = Number(localStorage.getItem("companyId") || 0);

  const load = async () => {
    const res = await client.get(
      `/suppliers${companyId ? `?companyId=${companyId}` : ""}`,
    );
    setRows(Array.isArray(res.data) ? res.data : []);
  };
  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    if (!form.supplierName.trim())
      return alert(
        "Supplier Name is required. Code will be auto-generated if blank.",
      );
    const payload = { ...form, companyId };
    try {
      setSaving(true);
      if (editingId) await client.put(`/suppliers/${editingId}`, payload);
      else await client.post("/suppliers", payload);
      setForm(empty);
      setEditingId(null);
      await load();
    } catch (e) {
      alert(
        e.response?.data?.message ||
          e.response?.data ||
          "Unable to save supplier",
      );
    } finally {
      setSaving(false);
    }
  };

  const edit = (r) => {
    setEditingId(val(r, "Id", "id"));
    setForm({
      supplierCode: val(r, "SupplierCode", "supplierCode"),
      supplierName: val(r, "SupplierName", "supplierName"),
      email: val(r, "Email", "email"),
      phone: val(r, "Phone", "phone"),
      addressLine: val(r, "AddressLine", "addressLine"),
      gstNo: val(r, "GSTNo", "gstNo"),
    });
  };
  const remove = async (r) => {
    if (!window.confirm("Deactivate this supplier?")) return;
    await client.delete(`/suppliers/${val(r, "Id", "id")}`);
    await load();
  };

  const inputStyle = { height: 30, fontSize: 11, borderRadius: 7 };
  const labelStyle = {
    fontSize: 10,
    fontWeight: 700,
    marginBottom: 3,
    color: "#495057",
  };
  const fields = [
    ["supplierCode", "Supplier Code (Auto)", "col-md-2"],
    ["supplierName", "Supplier Name", "col-md-2"],
    ["email", "Email", "col-md-2"],
    ["phone", "Phone", "col-md-2"],
    ["gstNo", "GST No", "col-md-2"],
    ["addressLine", "Address", "col-md-2"],
  ];

  return (
    <div className="container-fluid py-2" style={{ fontSize: 11, padding: 0 }}>
      <div
        className="card border-0 shadow-sm"
        style={{ borderRadius: 14, overflow: "hidden" }}
      >
        <div
          className="text-white"
          style={{
            background: "linear-gradient(90deg,#0b4f4a,#0f766e)",
            padding: "8px 12px",
          }}
        >
          <h6 className="m-0" style={{ fontSize: 13, fontWeight: 700 }}>
            <i className="bi bi-truck me-2"></i>Suppliers
          </h6>
          <div style={{ fontSize: 10, opacity: 0.85 }}>
            Supplier master for purchase vouchers, debit notes and payables
          </div>
        </div>
        <div className="card-body p-2">
          {editingId && (
            <div
              className="alert alert-warning py-1 mb-2"
              style={{ fontSize: 11 }}
            >
              Editing supplier #{editingId}
            </div>
          )}
          <div className="row g-2 mb-2">
            {fields.map(([key, label, col]) => (
              <div className={col} key={key}>
                <label style={labelStyle}>{label}</label>
                <input
                  className="form-control form-control-sm"
                  style={inputStyle}
                  value={form[key]}
                  onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                />
              </div>
            ))}
            <div className="col-md-2 d-flex gap-1 align-items-end">
              <button
                className="btn btn-success btn-sm flex-fill"
                style={{ height: 30, fontSize: 11 }}
                disabled={saving}
                onClick={save}
              >
                {saving ? "Saving..." : editingId ? "Update" : "Save"}
              </button>
              {editingId && (
                <button
                  className="btn btn-outline-secondary btn-sm"
                  style={{ height: 30, fontSize: 11 }}
                  onClick={() => {
                    setEditingId(null);
                    setForm(empty);
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
          <div
            className="table-responsive"
            style={{
              maxHeight: 420,
              border: "1px solid #e9ecef",
              borderRadius: 10,
            }}
          >
            <table
              className="table table-bordered table-hover mb-0"
              style={{ fontSize: 11, minWidth: 1000 }}
            >
              <thead className="table-dark">
                <tr>
                  {[
                    "Code",
                    "Name",
                    "Email",
                    "Phone",
                    "GST No",
                    "Address",
                    "Actions",
                  ].map((h) => (
                    <th key={h} style={{ fontSize: 10, whiteSpace: "nowrap" }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center text-muted py-3">
                      No suppliers found
                    </td>
                  </tr>
                ) : (
                  rows.map((r) => (
                    <tr key={val(r, "Id", "id")}>
                      <td className="fw-bold">
                        {val(r, "SupplierCode", "supplierCode")}
                      </td>
                      <td>{val(r, "SupplierName", "supplierName")}</td>
                      <td>{val(r, "Email", "email")}</td>
                      <td>{val(r, "Phone", "phone")}</td>
                      <td>{val(r, "GSTNo", "gstNo")}</td>
                      <td>{val(r, "AddressLine", "addressLine")}</td>
                      <td>
                        <button
                          className="btn btn-outline-primary btn-sm me-1"
                          style={{ fontSize: 10 }}
                          onClick={() => edit(r)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          style={{ fontSize: 10 }}
                          onClick={() => remove(r)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
